import React from "react";

const DragLine = props => {
  let { startx, starty, endx, endy } = props;
  return (
    <g>
      <circle cx={endx} cy={endy} r="8" fill="rgb(0, 132, 255)" />
     {/*  <circle cx={startx} cy={starty} r="8" fill="red" /> */}
      <line
        x1={startx}
        y1={starty}
        x2={endx}
        y2={endy}
        stroke="rgb(0, 132, 255)"
        strokeWidth="3"
      />
    </g>
  );
};

export default DragLine;
